import ShareContainer from './ShareContainer';

export default ShareContainer;
